import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import { type IAvatarInfo } from 'shared/ui'
import { type IResponseContact } from 'entities/Contacts/api/types'

export class TaggedContactsRow extends RowBase<IResponseContact> {
  constructor(origin: IResponseContact) {
    super(origin)
    makeObservableRowBase(this)
  }

  get full_name() {
    return this.origin.full_name
  }

  get avatarInfo(): IAvatarInfo {
    const isPhoneAbbr = !this.origin.first_name && !this.origin.last_name

    return {
      isPhoneAbbr,
      firstName: this.origin.first_name ?? '',
      lastName: this.origin.last_name ?? '',
      image: this.origin.photo_url,
      color: this.origin.color,
      number: this.origin.formatted_number || this.origin.number,
    }
  }

  get number() {
    return this.origin.number
  }

  get email() {
    return this.origin.email
  }

  get created_at() {
    return this.origin.created_at
  }
}
